// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { Modal } from "@mui/material";

// core components
import Button from "../CustomButtons/Button";
import Image from "next/image.js";
import ForumsModal from "../ForumsModal/ForumsModal";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// local assets
import closeIcon from "../../public/img/forums/icons/closeIcon.png";
import successIcon from "../../public/img/forums/icons/successIcon.png";

const useStyles = makeStyles()(styles);

export default function ForumsSuccessModal(props) {
    const { classes, cx } = useStyles();
    const type = props.type;
    const community = props.community;
    const question = props.question;

    return (
        <ForumsModal open={props.open} onClose={props.onClose} width={classes.width50}>
            <div className={classes.modalContent}>
                <Image className={classes.modalIcon} src={successIcon} alt={"success-icon"} width={100} height={100} />
                {type === "question" &&
                    <>
                        <h3 className={classes.modalTitle}>Question posted successfully</h3>
                        <p className={classes.modalText}>Your question has been posted in the {community} Community. It is currently being reviewed by our moderators.</p>
                    </>
                }
                {type === "reply" &&
                    <>
                        <h3 className={classes.modalTitle}>Reply posted successfully</h3>
                        <p className={classes.modalText}>Your reply has been posted.</p>
                    </>
                }
                {type === "share" &&
                    <>
                        <h3 className={classes.modalTitle}>Link copied</h3>
                        <p className={classes.modalText}>Your link has been copied to the clipboard.</p>
                    </>
                }
                <Button className={cx(classes.darkButton + " " + classes.mediumButton)} onClick={props.onClose}>Done</Button>
            </div>
        </ForumsModal>
    )
}

